<template>
  <div class="container">
    <!-- <u-sticky>
      <view class="sticky">
        <u-search input-align='center' placeholder="搜索停车场" v-model="keyword"></u-search>
        <u-dropdown>
          <u-dropdown-item v-model="value1" :title="value1==1?'夜间':'日间'" :options="options1"></u-dropdown-item>
          <u-dropdown-item v-model="value2" :title="value2==1?'距离优先':'价格优先'" :options="options2"></u-dropdown-item>
        </u-dropdown>
      </view>
    </u-sticky> -->
    <div class="order" v-for=" (item,index) of park" :key='index' @click="Jump(item)">
      <div class="top">
        <div class="left">
          <van-icon name="vip-card-o" :size="36" :color="item.type>1?'rgb(94,94,94)':'rgb(217,217,0)'"></van-icon>
          <div class="store">{{item.type>1?'夜间月卡':'日间月卡'}}</div>
        </div>
        <div class="right">待共享</div>
      </div>
      <div class="item">
        <div class="left">
          <div class="title">{{item.name}}</div>
          <div class="delivery-time">
            <van-icon name="guide-o" :size="30" color="rgb(94,94,94)"></van-icon>
            {{item.km}}
          </div>
        </div>
        <div class="right">
          <div class="price">
            ￥{{item.money}}
          </div>
        </div>
      </div>
      <van-divider></van-divider>
      <DIV class="bottom">
        <DIV class="more">
          {{item.type>1?'工作日 19:00-08:00':'工作日 08:00-19:00'}}
        </DIV>
        <DIV class="evaluate btn">不限次/月</DIV>
      </DIV>
    </div>
  </div>
</template>

<script>
import { Divider } from 'vant'
import { parseTime } from '@/utils'
export default {
  name: 'BindCar',
  components: {
    [Divider.name]: Divider,

  },
  computed: {
  },
  data () {
    return {
      value1: 1,
      value2: 1,
      park: [{
        type: 1,
        name: '龙江里停车场',
        money: 400,
        km: '1.6km | 南京市鼓楼区江东北路275号'
      }, {
        type: 1,
        name: '腾飞大厦地下停车场',
        money: 300,
        km: '3.17km | 南京市浦口区华创路'
      }, {
        type: 2,
        name: '大唐北路停车场',
        money: 150,
        km: '4.87km | 南京市鼓楼区北京西路80号'
      }, {
        type: 1,
        name: '航天晨光总部停车场',
        money: 200,
        km: '7.6km | 南京市江宁区将军大道199号'
      }, {
        type: 2,
        name: '桃湖公园停车场',
        money: 300,
        km: '11.16km | 南京市浦口区湖滨路'
      }, {
        type: 1,
        name: '军人俱乐部停车场',
        money: 250,
        km: '13.2km | 南京市鼓楼区中山北路1-5号'
      }, {
        type: 1,
        name: '红枫科技园停车场',
        money: 300,
        km: '21.1km | 南京市栖霞区科创路'
      }, {
        type: 2,
        name: '经贸学院站停车场',
        money: 240,
        km: '28.61km | 南京市江宁区龙眠大道180号'
      }, {
        type: 2,
        name: '亚东商业广场停车场',
        money: 400,
        km: '32.36km | 南京市栖霞区仙隐北路12号'
      }, {
        type: 1,
        name: '南理工科技创新园停车场',
        money: 400,
        km: '35.66km | 南京市玄武区光华路1号'
      }],
      options2: [
        {
          label: '距离优先',
          value: 1,
        },
        {
          label: '价格优先',
          value: 2,
        }
      ],
      options1: [{
        label: '夜间',
        value: 1,
      }, {
        label: '白天',
        value: 2,
      },
      ],
      FromData: {
        time: '',
        name: '',
        carNumber: '',
        park: ''
      },
      FromShow: {
        Time: false,
        CarNumber: false,
        Park: false
      },
      TimeParams: {
        year: true,
        month: true,
        day: true,
        hour: false,
        minute: false,
        second: false
      },
      ParkList: [
        {
          value: '1',
          label: '微信停车场'
        },
        {
          value: '2',
          label: '测试停车场'
        }
      ],
      CarNumberList: [
        {
          value: '1',
          label: '苏Z88888'
        },
        {
          value: '2',
          label: '苏Z77777'
        }
      ],
    }
  },
  onReady () {
    this.FromData.time = '2021-07-02'
  },
  methods: {
    Jump (item) {
      this.$Router.push({ name: 'shareorderdetailed', params: item });
    },
    TimeConfirm (e) {
      console.log(e);
      this.FromData.time = e.year + '-' + e.month + '-' + e.day
    },
    CarNumberConfirm (e) {
      console.log(e);
      this.FromData.carNumber = e[0].label
    },
    ParkConfirm (e) {
      console.log(e);
      this.FromData.park = e[0].label
    },
    ConfirmAppointment () {
      this.$refs.uToast.show({
        title: '预约成功',
        type: 'success',
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #f5f5f5;
  position: relative;
  .sticky {
    width: 750rpx;
    background-color: white;
    color: #fff;
    padding: 24rpx;
    border-bottom: 1px solid rgb(206, 206, 206);
  }
  .bind__header {
    display: flex;
    flex-direction: colunm;
    flex-wrap: wrap;
    padding: 25px;
    background: linear-gradient(
      -52deg,
      rgba(26, 73, 251, 1),
      rgba(71, 140, 245, 1)
    );

    &__info {
      width: 50%;
      color: rgba(255, 255, 255, 1);

      span {
        display: block;
      }

      &__title {
        font-size: 17px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        line-height: 26px;
      }

      &__content {
        font-size: 14px;
        line-height: 38px;
      }
    }

    &__2dpic {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 50%;
      height: 20vh;
      min-height: 140px;
    }
  }

  .bind-modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 600px;
    max-width: 90%;
    height: 60vh;
    min-height: 400px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(37, 44, 63, 0.1);
    border-radius: 5px;
    margin: 25vh auto 0;

    .title {
      text-align: center;
      font-size: 17px;
      line-height: 1.5;
      line-height: 1.5;
      padding: 25px 0 10px;
    }

    .btn_box {
      padding: 0 15px;
    }

    .page {
      padding: 10px;
    }
  }
  .order {
    width: 710rpx;
    background-color: #ffffff;
    box-shadow: 3rpx 3rpx 10rpx #bababa;
    margin: 20rpx auto;
    border-radius: 20rpx;
    box-sizing: border-box;
    padding: 20rpx;
    font-size: 28rpx;
    .top {
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        .store {
          margin: 0 10rpx;
          font-size: 26rpx;
          color: rgb(148, 148, 148);
          width: 120rpx;
          text-align: center;
          line-height: 40rpx;
          border-radius: 40rpx;
        }
      }
    }
    .item {
      display: flex;
      justify-content: space-between;
      margin: 20rpx 0 0;
      .left {
        .title {
          line-height: 50rpx;
          font-size: 32rpx;
          font-weight: bold;
        }
        .delivery-time {
          margin: 20rpx 0;
          color: #a0a0a0;
          font-size: 24rpx;
        }
      }
      .right {
        padding-top: 0rpx;
        text-align: right;
        font-size: 36rpx;
        font-weight: bold;
        color: rgb(93, 93, 93);
      }
    }
    .total {
      margin-top: 20rpx;
      text-align: right;
      font-size: 24rpx;
      .total-price {
        font-size: 32rpx;
      }
    }
    .bottom {
      display: flex;
      margin-top: 40rpx;
      justify-content: space-between;
      align-items: center;
      .more {
        font-size: 26rpx;
        color: rgb(148, 148, 148);
      }
      .btn {
        line-height: 52rpx;
        width: 160rpx;
        border-radius: 26rpx;
        font-size: 26rpx;
        text-align: center;
      }
    }
  }
  .centre {
    text-align: center;
    margin: 200rpx auto;
    font-size: 32rpx;
    image {
      width: 164rpx;
      height: 164rpx;
      border-radius: 50%;
      margin-bottom: 20rpx;
    }
    .tips {
      font-size: 24rpx;
      color: #999999;
      margin-top: 20rpx;
    }
    .btn {
      margin: 80rpx auto;
      width: 200rpx;
      border-radius: 32rpx;
      line-height: 64rpx;
      color: #ffffff;
      font-size: 26rpx;
      background: linear-gradient(
        270deg,
        rgba(249, 116, 90, 1) 0%,
        rgba(255, 158, 1, 1) 100%
      );
    }
  }
  .wrap {
    display: flex;
    flex-direction: column;
    height: calc(100vh - var(--window-top));
    width: 100%;
  }
  .swiper-box {
    flex: 1;
  }
  .swiper-item {
    height: 100%;
  }
}
</style>